var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/gbn.moscow/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/IndexFeatures/IndexFeatures.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/IndexFeatures/IndexFeatures.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n<div class=\"IndexFeatures\">\n    <div class=\"IndexFeatures-recommendations\">\n        <div class=\"IndexFeatures-recommendationsCount\">";
output += runtime.suppressValue((lineno = 4, colno = 80, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["5-of-6",runtime.makeKeywordArgs({"caller": (function (){var macro_t_4 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_5 = "";;
frame = frame.pop();
return new runtime.SafeString(t_5);
});
return macro_t_4;})()})])), env.opts.autoescape);
output += "</div>\n        <div class=\"IndexFeatures-recommendationsText\">клиентов, которые обратились к нам за услугами, приходят\n            повторно, а 2 из 3 рекомендуют друзьям\n        </div>\n    </div>\n    <div class=\"IndexFeatures-features\">\n        <div class=\"IndexFeatures-block\">\n            <div class=\"IndexFeatures-header\">Бесплатная оценка стоимости недвижимости</div>\n            <div class=\"IndexFeatures-desc\">Мы можем оценить стоимость недвижимости по телефону, но она будет неточной.\n                Чтобы оценить точно, мы можем приехать в удобное вам время. Это абсолютно бесплатно.\n            </div>\n        </div>\n        <div class=\"IndexFeatures-block\">\n            <div class=\"IndexFeatures-header\">Сделки по покупке и продаже без предоплаты</div>\n            <div class=\"IndexFeatures-desc\">Исключение только одно: вы платите до окончания сделки, когда вносите аванс\n                продавцу при&nbsp;покупке недвижимости.\n            </div>\n        </div>\n        <div class=\"IndexFeatures-block\">\n            <div class=\"IndexFeatures-header\">Деньги за рекомендацию</div>\n            <div class=\"IndexFeatures-desc\">Порекомендуйте нас друзьям. Если они подтвердят вашу рекомендацию, вы\n                получите 10% от нашей комиссии, когда сделка ваших друзей будет закрыта.\n            </div>\n        </div>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/IndexFeatures/IndexFeatures.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/IndexFeatures/IndexFeatures.jinja
// module id = 27
// module chunks = 0